module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.db33e70b.ttf";